export const socialObj = {
    id: 'facebook',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: '@EbenezerDallasGerizim',
    headline: 'Síguenos',
    buttonLabel: 'Mas Información',
    imgStart: false,
    dark: false,
    primary: false,
    darkText: true
};
